import { PlusInSquareIcon } from "assets/icons";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean, useSearchParameter } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useState } from "react";
import { Button, Pagination, SearchInput } from "ui";

import {
  DeleteProductSetModal,
  ProductSetDetailsModal,
  ProductSetFormModal,
  ProductSetsTable
} from "../../components";
import { useProductSetsList } from "../../hooks";

import styles from "./ProductSets.module.scss";

const ProductSets = () => {
  const {
    value: isOpenProductSetFormModal,
    setTrue: onOpenProductSetFormModal,
    setFalse: onCloseProductSetFormModal
  } = useBoolean();

  const {
    value: isOpenDeleteProductSetModal,
    setTrue: onOpenDeleteProductSetModal,
    setFalse: onCloseDeleteProductSetModal
  } = useBoolean();

  const [openedProductSetId, setOpenedProductSetId] = useState<string | null>(
    null
  );

  const [openedProductSetDetailsId, setOpenedProductSetDetailsId] =
    useSearchParameter("set_id");

  const {
    productSets,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    setProductSets
  } = useProductSetsList();

  return (
    <ContentLayout
      title={t("Product Sets")}
      counter={totalItems}
      action={
        <Button onClick={onOpenProductSetFormModal} icon={<PlusInSquareIcon />}>
          {t("New Set")}
        </Button>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder={t("Search...")}
        />

        <ProductSetsTable
          productSetsList={productSets}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          onDeleteProductSet={(id) => {
            setOpenedProductSetId(id);
            onOpenDeleteProductSetModal();
          }}
          onEditProductSet={(productSetId) => {
            setOpenedProductSetId(productSetId);
            onOpenProductSetFormModal();
          }}
          isDragDisabled={!!searchValue || sorting.length > 0}
          setProductSets={setProductSets}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <ProductSetFormModal
        isOpen={isOpenProductSetFormModal}
        onClose={() => {
          onCloseProductSetFormModal();
          setOpenedProductSetId(null);
        }}
        editableProductSetId={openedProductSetId}
      />

      <DeleteProductSetModal
        isOpen={isOpenDeleteProductSetModal}
        id={openedProductSetId}
        onClose={() => {
          onCloseDeleteProductSetModal();
          setOpenedProductSetId(null);
        }}
      />

      <ProductSetDetailsModal
        isOpen={!!openedProductSetDetailsId}
        onClose={() => setOpenedProductSetDetailsId(null)}
        setId={openedProductSetDetailsId}
      />
    </ContentLayout>
  );
};

export default ProductSets;
